// extracted by mini-css-extract-plugin
export default {"td":"PersonalizacaoAcessoIndex_td__5A2GS","trBody":"PersonalizacaoAcessoIndex_trBody__Oaoqb","inscricao":"PersonalizacaoAcessoIndex_inscricao__AQd4D"};